import React from 'react'
import CancelOrder from './CancelOrder'
import CreateEdit from './CreateEdit'
import {selectViewOrder} from 'app/features/orders/redux/order/orderSlice'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {ViewOrder} from 'app/features/orders/models/OrderState'
import {orderStatus} from 'app/features/orders/models'

interface Props {}

export const ViewActionWrapper: React.FC<Props> = () => {
  const order = useSelector<RootState, ViewOrder>(selectViewOrder)

  return (
    <div className='d-flex justify-content-end align-items-center flex-row'>
      <CancelOrder />
      {order.fulfillmentStatus !== orderStatus.restocked && <CreateEdit />}
    </div>
  )
}

export default ViewActionWrapper
